<div class="custom-tabs custom-tabs--with-title" *ngIf="(detectionType$ | async) as detectionType">
  <div class="custom-tabs__header">
    <div class="custom-tabs__title">
      <h5 class="m-0 text-on-surface-light-emphasis" *ngIf="false">
        {{detectionType === detectionTypes.List ? ('SmartDetection.ListOfDrivers'| translate) : ('SmartDetection.Map'| translate) }}
      </h5>

      <div class="drivers-type">
        <mat-checkbox [checked]="driversFreelanceChanged" (change)="onDriversFreelanceChanged($event)">
          {{ "Inputs.FreelanceDrivers"| translate }}
        </mat-checkbox>
        <mat-checkbox [checked]="driversFleetChanged" (change)="onDriversFleetChanged($event)">{{ "Inputs.RelatedDrivers"| translate }}</mat-checkbox>
      </div>
    </div>

    <div class="custom-tabs__tabs" *ngIf="false">
      <button
        mat-button
        type="button"
        class="custom-tabs__button btn"
        [ngClass]="{'btn-secondary': detectionType === detectionTypes.List}"
        (click)="detectionType$.next(detectionTypes.List)"
      >
        <app-icon name="menu" type="MaterialDesign"></app-icon>
      </button>

      <button
        mat-button
        type="button"
        class="custom-tabs__button btn ml-1"
        [ngClass]="{'btn-secondary': detectionType === detectionTypes.Map}"
        (click)="detectionType$.next(detectionTypes.Map)"
      >
        <app-icon name="pin_drop" type="MaterialDesign"></app-icon>
      </button>
    </div>
  </div>

  <div class="custom-tabs__content pt-4">
    <app-state-section
      content
      [state]="sectionState"
      [emptyStateImagePath]="'assets/images/empty-state.svg'"
      [emptyStateMainLabel]="'Providers.Drivers.EmptyStateMainLabel' | translate"
      [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"
    >
      <!-- *ngIf="detectionType === detectionTypes.List" -->
      <div class="custom-tabs__item">
        <mat-radio-group class="flex column card-list" [formControl]="selectedDriver">
          <mat-card
            class="card-list__item"
            [ngClass]="{'card-list__item--active': selectedDriver.value === driver}"
            *ngFor="let driver of (drivers$ | async)"
          >
            <div class="flex gaps align-center justify-space-between">
              <div class="box grow">
                <mat-radio-button class="flex column form-control-full-width" [value]="driver">
                  <div class="flex row align-center mb-1">
                    <div class="box nogrow">
                      <h6
                        class="my-0 mr-2 text-underline weight-bold text-primary"
                        app-click-stop-propagation
                        [routerLink]=" '/' + sharedConstants.VIEW_EDIT_DRIVER + '/' + driver.driverId"
                        target="_blank"
                      >
                        {{driver.name}}
                      </h6>
                    </div>

                    <div class="box">
                      <app-status-label [value]=" driver.shipmentId ? 'NOT_AVAILABLE' : 'AVAILABLE'"></app-status-label>
                    </div>
                  </div>
                  <div>
                    <p class="mb-1">
                      {{'SmartDetection.MobileNumber'| translate}}:
                      <b>{{driver.mobileNumber || '____'}}</b>
                    </p>
                    <p class="mb-1">
                      {{'SmartDetection.TruckPlateNo.'| translate}}:
                      <b class="text-underline text-primary" [routerLink]=" '/' + sharedConstants.VIEW_EDIT_TRUCK + '/' + driver.truckId">
                        {{driver.plateNumber || '____'}}
                      </b>
                    </p>
                    <p class="mb-1">
                      {{'Providers.VehicleType'| translate}}:
                      <b>{{driver.truckType || '____'}}</b>
                    </p>

                    <p class="mb-0">
                      {{'SmartDetection.Distance'| translate}}:

                      <b>{{(driver.distanceInMeters /1000)?.toFixed(2)}} Km</b>
                    </p>
                  </div>
                </mat-radio-button>
              </div>

              <div class="col" *ngIf="false">
                <div class="text-right">
                  <button mat-raised-button type="button" (click)="driverOnMap(driver.driverId)" class="btn btn-secondary text-primary">
                    <app-icon name="location_on" type="MaterialDesign"></app-icon>
                  </button>
                  <div class="text-primary">{{'SmartDetection.ViewOnMap'| translate}}</div>
                </div>
              </div>
            </div>
          </mat-card>
        </mat-radio-group>
      </div>
      <!-- *ngIf="detectionType === detectionTypes.Map"  -->
      <div class="custom-tabs__item" *ngIf="false">
        <div class="flex map flex column align-center" *ngIf="googleMapLoaded">
          <google-map [center]="{lat: +latitude, lng: +longitude }" [zoom]="zoom">
            <app-map-overlay
              [latitude]="+driver.latitude"
              [markerDraggable]="false"
              [longitude]="+driver.longitude"
              *ngFor="let driver of (drivers$ | async)"
            >
              <div class="overlay">
                <div class="layer-one" [class.unavailable]="driver.driverId">
                  <div class="layer-two" [class.unavailable]="driver.driverId">
                    <div class="image map__pin flex justify-center align-center" [ngClass]="{'highlight__map__pin': highlightedDriverId}">
                      <img [src]="'assets/images/tracking-driver.svg'" (click)="selectedDriver.setValue(driver)" />
                    </div>
                  </div>
                </div>
              </div>
            </app-map-overlay>
          </google-map>
          <div class="map__slider slider">
            <div class="slider__label">1 Km</div>
            <div class="slider__control-wrapper">
              <mat-slider
                class="slider__control"
                [min]="1"
                [max]="1000"
                [step]="1"
                [ngModel]="distanceRange"
                (ngModelChange)="onRangeChange($event)"
              ></mat-slider>
              <div class="slider__control-value" [style]="{left: (distanceRange/10) + '%'}">{{distanceRange}} Km</div>
            </div>
            <div class="slider__label">1000 Km</div>
          </div>
        </div>
      </div>
    </app-state-section>
  </div>
</div>
